<script>

export default {
    name: "EllipseComponent",

    emits: ['click'],

    props: {
        productId: {
            type: Number|String
        },
        active: {
            type: Boolean
        },
        value: {
            // type: Number|String|null
        },
        ellipseClass: {
            type: String,
        },
        animation: {
            type: String,
        },
    },

    methods:
    {
        click(){
            this.animate = true;
            this.$emit('click');
            setTimeout(() => this.animate = false, 1500)
        },
    },

    data() {
        return {
            animate: false,
        };
    },

    computed: {
        ellipseActive(){
            return this.active ? 'active' : '';
        },
        animationClass(){
            return this.animate && this.animation ? this.animation : '';
        }
    },
    
};

</script>

<template>
    <div :id="'add-'+productId" :class="[ellipseClass, ellipseActive, animationClass]" @click="click" v-html="value"></div>
</template>
